export const ChannelGroups = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">Channel Groups</h1>
        </div>
    )
}